export enum errorCode {
  robotFail = "robotFail"
}
